import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";
// Define a service using a base URL and expected endpoints
export const foodStationOptionsApi = createApi({
  reducerPath: "foodStationOptionsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FoodStationOptions"],
  endpoints: (builder) => ({
    getStationOptionsList: builder.query({
      query: ({ id, subDomain }) => {
        return {
          url: `/station-option/${id}/list`,
          method: "GET",
          params: { subdomain: subDomain },
        };
      },
      transformResponse: (response) => {
        response.map((a) => {
          return {
            group: a.group,
            items: a.items.sort((a, b) => a.order - b.order),
          };
        });
        return response;
      },
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "FoodStationOptions", id })),
              { type: "FoodStationOptions", id: "LIST" },
            ]
          : [{ type: "FoodStationOptions", id: "LIST" }];
      },
    }),
    saveOptionsOrder: builder.mutation({
      query: ({ payload, subDomain }) => {
        return {
          url: `/station-option/update-list`,
          method: "POST",
          body: payload,
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    saveGroupOrder: builder.mutation({
      query: ({ payload, subDomain }) => {
        return {
          url: `/station-option/group/update-list`,
          method: "POST",
          body: payload,
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    createOptionGroup: builder.mutation({
      query: (payload) => {
        return {
          url: `/station-option/group/create`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    updateOptionGroup: builder.mutation({
      query: ({ id, data, subDomain }) => {
        return {
          url: `/station-option/group/${id}`,
          method: "PATCH",
          body: { ...data },
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    deleteOptionGroup: builder.mutation({
      query: ({ id, subDomain }) => {
        return {
          url: `/station-option/group/${id}`,
          method: "DELETE",
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    createOption: builder.mutation({
      query: ({ data, subDomain }) => {
        return {
          url: `/station-option/create`,
          method: "POST",
          body: { ...data },
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    updateOption: builder.mutation({
      query: ({ id, data, subDomain }) => {
        return {
          url: `/station-option/${id}`,
          method: "PATCH",
          body: { ...data },
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    deleteOption: builder.mutation({
      query: ({ id, subDomain }) => {
        return {
          url: `/station-option/${id}`,
          method: "DELETE",
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
    uploadImage: builder.mutation({
      query: ({ id, subdomain, data, groupId, optionId }) => {
        const formData = new FormData();
        formData.append("file", data);
        formData.append("group_id", groupId);
        formData.append("option_id", optionId);
        return {
          url: `/station-option/image/upload/${id}`,
          method: "POST",
          body: formData,
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStationOptions", id: "LIST" }],
    }),
  }),
});

export const {
  useGetStationOptionsListQuery,
  useLazyGetStationOptionsListQuery,
  useSaveOptionsOrderMutation,
  useSaveGroupOrderMutation,
  useCreateOptionGroupMutation,
  useUpdateOptionGroupMutation,
  useDeleteOptionGroupMutation,
  useCreateOptionMutation,
  useUpdateOptionMutation,
  useDeleteOptionMutation,
  useUploadImageMutation,
} = foodStationOptionsApi;
